module.exports = __webpack_public_path__ + "img/bird-8.5479bb24.png";